// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import BaseIcon, { type IconProps } from './BaseIcon'
import { avatarBgCss, avatarFaceCss, avatarShadowCss, avatarShirtCss } from './avatarStyles'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path fill="#dfdfdf" d="M0 0h24v24H0z" className={avatarBgCss} />
    <path
      fill="#9c9e9e"
      fillRule="evenodd"
      d="M8.76 17.59C8.51 18 4 21.33 4 21.33h14.67A48 48 0 0 1 15 17.59a7 7 0 0 1-.75-3.15 8 8 0 0 0 1.43-2.83c.45 1.85 1.82-3 .61-3q-.25.01-.39.4c.46-8-8.61-7.43-8.29 0q-.13-.37-.39-.38c-1.08-.1 0 4.6.59 3.16A8 8 0 0 0 9 14.17a8 8 0 0 1-.24 3.42"
      className={avatarFaceCss}
    />
    <path
      fill="#8f8f8f"
      fillRule="evenodd"
      d="M9 14.17c0 .45.05.95.05 1.43 1.22 1.27 2.37 3.16 6 2v-.05a7 7 0 0 1-.75-3.15c-1.56 1.85-3.74 1.75-5.27-.3Z"
      className={avatarShadowCss}
    />
    <path
      fill="#747779"
      d="M20 24a10 10 0 0 0 .4-2.93c0-2.31-4.91-2.94-4.91-2.94s-.79 2.23-4 2.23a4.3 4.3 0 0 1-3.44-2.13c-.72.2-4.74.6-4.74 2.86S4 24 4 24Z"
      className={avatarShirtCss}
    />
  </BaseIcon>
)
